export const PERMISSION_VALUES = [
  'CREATE_OPPORTUNITY',
  'LIST_OPPORTUNITIES',
  'GET_OPPORTUNITY',
  'CREATE_USER',
  'LIST_USERS',
  'GET_USER',
  'UPDATE_USER',
  'DISABLE_USER',
  'ENABLE_USER',
  'LIST_ROLES',
  'VERIFY_PROSPECT',
  'VALIDATE_PROSPECT',
  'VERIFY_SITE',
  'TRIGGER_LOAD_CURVE',
  'CREATE_OFFER',
  'VALIDATE_OFFER',
  'REOPEN_OFFER',
  'SAVE_CONTRACT',
  'GET_CONTRACT_DOCUMENT',
  'SEARCH_PAYER',
  'ASSIGN_ROLE',
  'LIST_KPI',
  'LIST_BROKERS_KPI',
  'MANAGE_BROKERS',
  'CHECK_VISIBLE_OPPORTUNITIES',
  'GET_OWN_PROFILE_PHOTO',
] as const;

export type Permission = (typeof PERMISSION_VALUES)[number];

export function isPermission(value: string): value is Permission {
  return PERMISSION_VALUES.includes(value as Permission);
}
